import A from './ActionCreators';
import G from './Getters';
import { useContext } from 'react';
import { useStore, useDispatch } from 'react-redux';
import usePresentSelector from './usePresentSelector';
import useEditorDispatch from './useEditorDispatch';

import ImageIcon from '@material-ui/icons/Image';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import { SelectedItemsDispatch } from './SelectedItemProvider';

function validateReqs(reqs){

  let missingKey = Object.keys(reqs).find(keyName => !reqs[keyName]);
  
  if( missingKey ){ 
    throw Error("Missing required prop: '"+missingKey+"'");
  }

}


export default function TableActionToolbar({shouldSplitText, onItemClicked, itemOrder, figurePanelId, 
  selectedFigureItems,
  location
}){

  const store = useStore();

  const editorDispatch = useEditorDispatch();

  let setSelectedItems = useContext(SelectedItemsDispatch);

  let selectedCells = selectedFigureItems.cells || [];


  let reqs = { selectedCells };
  validateReqs(reqs);


  const dispatch = useDispatch();

  




  let editorStyle = usePresentSelector(state => state.editorStyle);

  let selectedRows = Array.from(new Set(selectedCells.map(cell => cell[0])))
  let selectedCols = Array.from(new Set(selectedCells.map(cell => cell[1])))

 


  let canMergeSelectedCells = usePresentSelector(state => {
    if( !selectedCells ){
      throw Error("The selected cells property was removed, but we're trying to read from it when checking mergeability.");
    }
    return G.canMergeCells(state,{figurePanelId,cells:selectedCells})
  });

  const buttonTextComponent = (text) => {
    if(shouldSplitText===false){
      return <div style={{margin:2.5,textAlign:'left'}}>{text}</div>
    }
    let split = text.split(' ');
    return split.map( (word,iiWord) => {
      return (
        <div style={{fontSize:9}}>
          {word}
          {iiWord < split.length - 1 && <br/>}
        </div>
      )
    })
  }

  const Space = ({}) => (

    <div className="thin-vertical-line" 
      style={{marginLeft:'3px',marginRight:'3px',width:'1px'}}>
    </div>

  )


  const insertGridItem = (item,direction) => {

    let disabled = false;
    if( item === "row" ){
      disabled = (selectedRows.length > 1)
    }else if( item === "column" ){
      disabled = (selectedCols.length > 1)
    }
    const text = buttonTextComponent(
      item + ' ' + direction
    )

    return ( (
      <MyDiv {...{
        location,
        onItemClicked,
        action:`add-row-${direction}`,
        onClick:() => {
          editorDispatch({
            type:"insertGridItem",
            item,
            direction
          })
        },
        //hoverable:false,
        disabled,
      }}>
        {<div class="sg-row v-center">
          <AddIcon style={{fontSize:20}}/>
          <div> {text} </div>

          {/*<div style={{ textAlign:'right', 
            paddingRight:5
            }} class="flex-expand">
            <div class="hoverable">above</div>
            <div class="hoverable">below</div>
          </div>*/}


        </div>}
      </MyDiv>
    )
    )
  }

  


  let components = {

    editChannels:((<MyDiv 
        onItemClicked={onItemClicked}
        location={location}
        action={"edit-channels"}
        disabled={selectedCells.length !== 1}
        onClick={
        ()=>{

          let selectedCells = selectedFigureItems.cells || [];
          let state = store.getState();

          const cellData = G.getCellsValue(state,{figurePanelId,cells:selectedCells})[0];


          let modalArgs = {
            type:"setModal",
            useCase:"editChannels",
            modal:"insertImage",
            cellLocation:selectedCells[0],
            cellData
          }

          editorDispatch(modalArgs)
          }}>
      {<div class="sg-row v-center">
        <ImageIcon style={{fontSize:20}}/>
        {buttonTextComponent("Edit channels")}
      </div>}
      </MyDiv>)
    ),
    insertImage:((<MyDiv 
        onItemClicked={onItemClicked}
        location={location}
        action={"set-image"}
        disabled={selectedCells.length !== 1}
        onClick={
        ()=>{

          let selectedCells = selectedFigureItems.cells || [];
          let state = store.getState();

          const cellData = G.getCellsValue(state,{figurePanelId,cells:selectedCells});


          let modalArgs = {
            type:"setModal",
            useCase:"insert",
            //figurePanelId,
            modal:"insertImage",
            cellLocation:selectedCells[0],
            cellData
          }

          editorDispatch(modalArgs)

          }}>
      {<div class="sg-row v-center">
        <ImageIcon style={{fontSize:20}}/>
        {buttonTextComponent("Set image")}
      </div>}
      </MyDiv>)
    ),
    deleteRow:(<MyDiv 
        onItemClicked={onItemClicked}
        location={location}
        action={"row-delete"}
        disabled={selectedRows.length === 0}
        onClick={
        ()=>{
          editorDispatch({
            type:"deleteRows"
          })
          }}>
        {<div class="sg-row v-center">
          <DeleteIcon style={{fontSize:20}}/>
        {buttonTextComponent("Delete row"+(selectedRows.length > 1 ? "(s)" : ""))}
        </div>}
      </MyDiv>),
    deleteColumn:(<MyDiv
      onItemClicked={onItemClicked}
        location={location}
        action={"col-delete"}
        disabled={selectedCols.length === 0}
        onClick={
          ()=>{
            setSelectedItems({});
            dispatch(A.deleteColumn(
            {figurePanelId,selectedCells}
          ))}}>

      {<div class="sg-row v-center">
          <DeleteIcon style={{fontSize:20}}/>

        {buttonTextComponent("Delete column"+(selectedCols.length > 1 ? "(s)" : ""))}
      </div>}
      </MyDiv>),
    split:(

      <MyDiv 
        onItemClicked={onItemClicked}
        location={location}
        action={"cell-split"}
        disabled={selectedCells.length === 0}
        onClick={() => {

          dispatch(A.splitCells({
            cells:selectedCells,
            figurePanelId,
            deselectCells:true
          }))
          

        }}>{buttonTextComponent("Split cells")}</MyDiv>

    ),
    merge:(

      <MyDiv {...{
        location,
        action:'cell-merge',
        onItemClicked,
        onClick:() => {
          dispatch(
            A.mergeCells(
              {cells:selectedCells,figurePanelId}
          ))
        },
        disabled:!canMergeSelectedCells
      }}>
        {buttonTextComponent(`Merge cells`)}
      </MyDiv>

    ),
    line:<div style={{
      height:1,width:'100%',
      background:'#ccc'

    }}/>,

    addRowAbove:insertGridItem("row","above"),
    addRowBelow:insertGridItem("row","below"),
    addColumnLeft:insertGridItem("column","left"),
    addColumnRight:insertGridItem("column","right"),

  }

  let defaultOrder = ['deleteRow','deleteColumn','split','merge'];

  let resultantOrder = (itemOrder||defaultOrder)

  let result = resultantOrder.map((item,ii) => {
    let defaultArgs = {
      location,
      onItemClicked,
    }
   return  <>
      
      {components[item]}
      {(ii !== resultantOrder.length - 1) && <Space/>}
    </>
  })

  return result;

}

function MyDiv({action,disabled,children,className,onClick,location, onItemClicked, hoverable}){
    let classModification = disabled ? "disabled-button" : (
      hoverable!==false && "hoverable"
    );

    let resolvedClass = classModification + " toolbar-action-button toolbar-button";

    return (
      <div 
        location={location}

        action={action}

        onClick={() => {
          if( !disabled ){
            onClick && onClick();
            onItemClicked && onItemClicked();
          }

        }} className={resolvedClass}>{children}</div>
    )
  }
